var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[_c('organization-details-address-add',{attrs:{"organization":_vm.organization}}),_c('org-details-address-edit',{attrs:{"organization":_vm.organization}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }